import { ReactSession } from 'react-client-session'

ReactSession.setStoreType('localStorage')

export default ReactSession
